<template>
  <div id="app">
    <v-dialog/>
    <div class="pure-g nav">
      <div style="text-align: left;" class="pure-u-1-2">
        <img id="logo" src="/logo.png"/>
      </div>
      <div v-if="isNavVisible()" class="pure-u-1-2 toolbar">
        <div class="pure-menu pure-menu-horizontal toolbarMenu">
          <li class="pure-menu-item"><router-link class="pure-menu-link" to="/" >Home</router-link></li>
          <li class="pure-menu-item"><router-link class="pure-menu-link" to="/about">About</router-link></li>
          <li class="pure-menu-item logout"><a class="pure-menu-link" v-on:click="logout" href="#">Logout</a></li>
        </div>
      </div>
    </div>

      <router-view/>

  </div>
</template>

<script>
import { doLogout } from "@/utils/auth.js";
import { isLoggedIn } from "@/utils/auth.js";

export default {
  name: "app",
  methods: {
    logout: function(event) {
      doLogout();
    },

    isNavVisible: function(event) {
      return isLoggedIn();
    }
  }
};
</script>

<style>
body {
  margin: 0px;
}

/* 
  General layout styles
*/

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #003366;
  position: relative;
}

#logo {
  alignment: left;
  left: 15px;
  width: 164px;
  margin-top: 14px;
  margin-left: 17px;
}

legend {
  text-align: left;
}

a {
  cursor: pointer;
}

.nav {
  padding: 0px;
  height: 70px;
  top: 0px;
  position: relative;
  width: 100%;
  background-color:#ffffff;
  border-bottom: 1px solid #6699cc;
}

.toolbar {
  text-align: right;
  position: relative;
}

.toolbarMenu {
  padding-right: 20px;
  padding-top: 15px;
}

.nav-header {
  position: relative;
  text-align: left;
  padding-left: 20px;
}

.nav a {
  font-weight: bold;
  color: #6699cc;
  text-decoration: none;
}

.logout {
  border: solid 2px #6699cc;
}

/* 
  General widget styles
*/

input {
  height: 1.9rem;
  padding: 0em 1em;
  color: #333333;
  font-size: 0.9rem;
}


select {
  height: 1.9rem;
  padding: 0em 1em;
  color: #333333;
  font-size: 0.9rem;
}

p {
  color: #444444;
}

.pure-form legend {
  font-size: 1.3rem;
  color: #888888;
  margin-top: 0px;
}

/*
  Styles for dialog
*/

.vue-dialog .dialog-c-text {
  font-family: Helvetica, Arial, sans-serif;
  text-align: left;
  color: #444444;
  font-size: 1rem;
}

.vue-dialog .dialog-c-title {
  font-family: Helvetica, Arial, sans-serif;
  text-align: left;
  color: #3366cc;
  font-size: 1.1rem;
}

.vue-dialog .vue-dialog-button {
  color: #6699cc;
  font-size: 1rem !important;
  font-weight: bold;
}

.dialog-button {
  color: white;
  background-color: #6699cc;
  border: 1px #6699cc;
  border-radius: 5px;
  padding: 7px;

}
/*
  Styles for table views
*/

.menuBarBox {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.menuBar {
  text-align: right;
  position: relative;
  font-weight: bold;
}

.searchBar {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 5px;
  display: grid;
}

.searchField {
  float: left;
}

.searchButton {
  float: left;
}

.tableBox {
  margin-left: 20px;
  margin-right: 20px;
}

.table {
  margin-top: 5px;
  width: 100%;
  text-align: left;
}

.table td {
  padding-top: 4px;
  padding-bottom: 0px;
}

.colAction {
  width: 50px;
}

.tableNav {
  color: #6699cc;
  font-weight: bold;
  text-align: left;
}

.tableNav .pure-menu-link {
  color: #6699cc;
  font-weight: bold;
  padding-left: 7px;
  padding-right: 7px;
  cursor: pointer;
}

/* 
  General form view styles
*/

.formBox {
    margin-top: 0px;
    margin-left: 20px;
    margin-right: 20px;
    text-align: left;
}

.comment {
    resize: none;
}

/*
  DatePicker
*/
.vdp-datepicker__calendar .cell.selected {
  background-color: #6699cc;
  color: white;
}

.vdp-datepicker__calendar .cell.selected:hover {
  background-color: #336699;
  color: white;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #336699;
}

/*
 Menu
 */

li.menu-info {

  font-size: 0.9rem;
  font-weight: normal;
  line-height: 1.5rem;
  color: #003366;
}

/*
  Info Table
 */
table.infoTable {
  border: 10px;
  border-color: #eeeeee;
  border-style: solid;
  background-color: #eeeeee;
}

table.infoTable td {
  padding: 5px;
}

</style>
